<!--  -->
<template>
  <div class="footer">
    <div class="footer__main">
      <div class="footer__left">
        <div class="footer__left__ul">
          <div class="footer__left__ul__tit">{{ $t('homePage.aboutUs') }}</div>
          <!-- 跳转关于我们 -->
          <p class="footer__left__ul__desc">
            <a href="https://mal.io/about">{{ $t('homePage.subAboutUs') }}</a>
            <!-- <router-link to="/about">{{ $t('homePage.subAboutUs') }}</router-link> -->
          </p>
          <!-- 弹出商业合作弹窗 -->
          <p class="footer__left__ul__desc" @click="popBusiness = true">{{ $t('homePage.business') }}</p>
          <!-- 弹出社区弹框 -->
          <p class="footer__left__ul__desc" @click="popCommunity = true">{{ $t('homePage.community') }}</p>
          <!-- 跳转服务协议 -->
          <p class="footer__left__ul__desc">
            <a
                :href="`https://doc.mal.io/${langShort}/user-agreement`"
                class=""
                target="_blank"
                >{{ $t('homePage.serviceAgreement') }}</a
              >
              <!-- <router-link to="/service">{{ $t('homePage.serviceAgreement') }}</router-link> -->
          </p>
          <!-- 跳转隐私保护 -->
          <!-- <p class="footer__left__ul__desc">
            <router-link to="/privacy">{{ $t('homePage.privacyProtection') }}</router-link>
          </p> -->
        </div>
        <div class="footer__left__ul">
          <div class="footer__left__ul__tit">{{ $t('homePage.products') }}</div>
          <!-- 跳转数字货币交易页面 -->
          <p class="footer__left__ul__desc">
            <!-- <router-link to="/trade">{{ $t('homePage.digitalTrading') }}</router-link> -->
            <a href="https://mal.io/trade">{{ $t('homePage.digitalTrading') }}</a>
          </p>
          <!-- 跳转法币充值页面 -->
          <p class="footer__left__ul__desc" @click="handleUserPage()">
            {{ $t('homePage.fiatRecharge') }}
          </p>
          <!-- 跳转数字货币交易页面 -->
          <p class="footer__left__ul__desc" >
            <!-- <router-link to="/trade">{{ $t('homePage.digitalPurchases') }}</router-link> -->
            <a href="https://mal.io/trade">{{ $t('homePage.digitalPurchases') }}</a>
          </p>
          <p class="footer__left__ul__desc">
            <a href="https://www.savethechildren.org" target="_blank">{{ $t('homePage.charity') }}</a>
          </p>
          <!-- 弹出NFT弹框 -->
          <p class="footer__left__ul__desc" @click="popNft = true">NFT</p>
        </div>
        <div class="footer__left__ul">
          <div class="footer__left__ul__tit">{{ $t('homePage.services') }}</div>
          <!-- 跳转下载页 -->
          <p class="footer__left__ul__desc">
            <!-- <router-link to="/app-download">{{ $t('homePage.clientDownload') }}</router-link> -->
            <a href="https://mal.io/app-download">{{ $t('homePage.clientDownload') }}</a>
          </p>
          <!-- 弹出上币申请弹框 -->
          <p class="footer__left__ul__desc" @click="toApply">{{ $t('homePage.listingApplication') }}</p>
          <!-- 跳转费率页面 -->
          <p class="footer__left__ul__desc">
            <!-- <router-link to="/fee">{{ $t('homePage.feeRates') }}</router-link> -->
            <a href="https://mal.io/fee">{{ $t('homePage.feeRates') }}</a>
          </p>
          <!-- 跳转邀请页面 -->
          <p class="footer__left__ul__desc">
            <!-- {{ $t('homePage.historicalData') }} -->
            <!-- <router-link to="/invitation-center">{{ $t('homePage.invitations') }}</router-link> -->
            <a href="https://mal.io/invitation-center">{{ $t('homePage.invitations') }}</a>
          </p>
        </div>
        <div class="footer__left__ul">
          <div class="footer__left__ul__tit">
            {{ $t('homePage.help') }}
          </div>
          <!-- 跳转帮助中心 -->
          <p class="footer__left__ul__desc">
            <!-- <router-link to="/help">{{ $t('homePage.helpCenter') }}</router-link> -->
            <a :href="`https://doc.mal.io/${langShort}/help-center`" target="_blank">{{ $t('homePage.helpCenter') }}</a>
          </p>
          <p class="footer__left__ul__desc no-cursor" >{{ $t('homePage.onlineCustomerService') }}</p>
          <!-- 弹出邮箱弹框 -->
          <p class="footer__left__ul__desc" @click="popCooperate = true">{{ $t('homePage.suggestionsAndFeedback') }}</p>
          <!-- 跳转公告中心 -->
          <p class="footer__left__ul__desc">
            <!-- <router-link to="/notice">{{ $t('homePage.announcementCenter') }}</router-link> -->
            <a :href="`https://malio.zendesk.com/hc/${langShort}`" target="_blank">{{ $t('homePage.announcementCenter') }}</a>
          </p>
        </div>
      </div>
      <div class="footer__right">
        <div class="footer__right__title">Mal.io</div>
        <div class="footer__right__desc">{{ $t('homePage.financeGateway') }}</div>
        <div v-if="isLogin" class="footer__right__btn" @click="toInvite">{{ $t('homePage.invitationRebate')}}</div>
        <div v-else class="footer__right__btn" @click="handleJoinNow">{{ $t('homePage.joinNow') }}</div>
        <div class="footer__right__media">{{ $t('homePage.socialMedia') }}</div>
        <div class="footer__right__medias">
          <a href="https://twitter.com/MalFinance" target="_blank">
            <div class="footer__right__medias--icon twitter" ></div>
          </a>
          <a href="https://t.me/mal_io" target="_blank">
            <div class="footer__right__medias--icon telegram"></div>
          </a>
          <a href="https://youtube.com/channel/UCChWLjFpifD4L1oymW0NBZQ" target="_blank">
            <div class="footer__right__medias--icon youtube" ></div>
          </a>
          <a href="http://tiktok.com/@mal.io1" target="_blank">
            <div class="footer__right__medias--icon tiktok"></div>
          </a>
        </div>
      </div>
      <div ref="tawk"></div>
    </div>
    <!-- NFT弹窗 -->
    <PopupNft v-model="popNft"></PopupNft>
    <!-- 上币服务弹窗 -->
    <PopupIssuanceApplication v-model="popApply"></PopupIssuanceApplication>
    <!-- 商务合作弹窗 -->
    <PopupCooperate v-model="popCooperate"></PopupCooperate>
    <!-- 加入社区弹窗 -->
    <PopupJoinCommunity v-model="popCommunity"></PopupJoinCommunity>
    <PopupBusiness v-model="popBusiness"></PopupBusiness>
  </div>
</template>

<script>
import Cookie from '@/api/cookie';
// eslint-disable-next-line import/no-unresolved
import PopupNft from '@/components/home/PopupNft.vue';
import PopupIssuanceApplication from '@/components/home/PopupIssuanceApplication.vue';
import PopupCooperate from '@/components/home/PopupCooperate.vue';
import PopupJoinCommunity from '@/components/home/PopupJoinCommunity.vue';
import PopupBusiness from '@/components/home/PopupBusiness.vue';

export default {
  data() {
    return {
      popNft: false,
      popApply: false,
      popCooperate: false,
      popCommunity: false,
      popBusiness: false,
    };
  },
  props: {},
  components: {
    PopupNft,
    PopupIssuanceApplication,
    PopupCooperate,
    PopupJoinCommunity,
    PopupBusiness,
  },
  computed: {
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    langShort() {
      return this.$i18n.locale.split('_')[0];
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      const lang = this.$i18n.locale;
      let tawkLang = '1fk7hdutj';
      if (lang === 'ar_SA') {
        tawkLang = '1fifj99p4';
      }
      const s = document.createElement('script');
      s.setAttribute('type', 'text/javascript');
      s.textContent = `
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src='https://embed.tawk.to/61706fc786aee40a57379370/${tawkLang}';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);
      })();`;
      document.body.appendChild(s);
    });
  },
  methods: {
    // handleClick() {
    //   if (!Cookie.getItem('token')) {
    //     return this.$router.push('/login');
    //   }
    // },
    toInvite() {
      // this.$router.push('/invitation-center');
      window.location.href = 'https://mal.io/invitation-center';
    },
    handleJoinNow() {
      window.location.href = 'https://mal.io/register';
      // this.$router.push('/register');
    },

    handlePop(name) {
      this[name] = true;
    },
    handleCustomerService() {
      console.log('111', document.querySelector('.tawk-min-container'));
      document.querySelector('.tawk-min-container > button')[0].click();
    },
    handleUserPage() {
      if (!Cookie.getItem('token')) {
        // this.$router.push('/login');
        window.location.href = 'https://mal.io/login';
        return;
      }
      window.location.href = 'https://mal.io/assets/fiat-recharge';
    },
    toApply() {
      if (this.langShort === 'en') {
        window.location.href = 'https://forms.gle/maCrMbayr9eJ8BKt7';
      } else {
        window.location.href = 'https://forms.gle/8gdrPF4q1oncLgXr9';
      }
    },
  },
};
</script>

<style lang='scss' scoped>
$iconTwitter: '~@/assets/images/home/green-twitter.png';
$iconTelegram: '~@/assets/images/home/green-telegram.png';
$iconYoutube: '~@/assets/images/home/green-youtube.png';
$iconTiktok: '~@/assets/images/home/green-tiktok.png';
$iconTwitterHover: '~@/assets/images/home/twitter-hover.svg';
$iconTelegramHover: '~@/assets/images/home/telegram-hover.svg';
$iconYoutubeHover: '~@/assets/images/home/youtube-hover.svg';
$iconTiktokHover: '~@/assets/images/home/tiktok-hover.svg';
a {
  color: #b1b1b1;
}
.footer {
  background:#000;

  &__main {
    max-width: 1202px;
    margin: 0 auto;
    color: #FFFFFF;
    display: flex;
  }

  &__left,
  &__right {
    flex: 1;
    padding: 85px 0 200px;
  }

  &__left {
    display: flex;

    &__ul {
      width: 235px;

      &__tit {
        font-size: 24px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 33px;
        margin-bottom: 49px;
      }

      &__desc {
        font-size: 14px;
        color: #B1B1B1;
        line-height: 22px;
        margin-bottom: 25px;
        cursor: pointer;

        &.no-cursor {
          cursor: auto;
        }
      }
    }
  }

  &__right {
    &__title {
      font-size: 24px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 33px;
    }

    &__desc {
      font-size: 16px;
      font-family: Helvetica;
      color: #B1B1B1;
      line-height: 19px;
      margin-top: 11px;
      cursor: pointer;
    }

    &__btn {
      width: 182px;
      height: 56px;
      background: #00A150;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      margin-top: 33px;
      cursor: pointer;
    }

    &__media {
      font-size: 24px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 33px;
      margin-top: 54px;
    }

    &__medias {
      margin-top: 20px;
      width: 254px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &--icon {
        width: 36px;
        height: 36px;
        background-position: top center;
        background-size: contain;
        background-repeat: no-repeat;

      }
      .twitter {
        background-image: url($iconTwitter);
        // &:hover {
        //   background-image: url(iconTwitterHover);
        // }
      }
      .telegram {
        background-image: url($iconTelegram);
        // &:hover {
        //   background-image: url(iconTelegramHover);
        // }
      }
      .youtube {
        background-image: url($iconYoutube);
        // &:hover {
        //   background-image: url(iconYoutubeHover);
        // }
      }
      .tiktok {
        background-image: url($iconTiktok);
        // &:hover {
        //   background-image: url(iconTiktokHover);
        // }
      }
    }
  }
}
@media only screen and (max-width: 769px) {
  .footer {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;

    &__main {
      flex-direction: column-reverse;
    }

    &__right {
      padding: 26px 0 36px;

      &__title {
        font-size: 25px;
      }

      &__desc {
        font-size: 13px;
        margin-top: 0;
      }

      &__btn {
        height: 48px;
        margin-top: 19px;
      }

      &__media {
        margin-top: 28px;
        font-size: 15px;
      }

      &__medias {
        width: 185px;
      }

      &__medias--icon {
        width: 28px;
        height: 28px;
      }
    }

    &__left {
      flex-direction: column;
      padding-top: 0;
      padding-bottom: 100px;

      &__ul {
        &__tit {
          font-size: 15px;
          line-height: 21px;
          margin-bottom: 14px;
        }

        &__desc {
          font-size: 13px;
          margin-bottom: 12px;
          display: none;
        }
      }
    }
  }
}
</style>
